import axios from 'axios';

const url = process.env.VUE_APP_HOST;
const home = process.env.VUE_APP_HOME;

const getUserProfile = async function (){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
        if (!access_token)
        {
            var query = window.location.hash
            .slice(2)
            .split('&')
            .filter(function(param) {
                return !!param;
            })
            .reduce(function(memo, param) {
                var keyValue = param.split('=');
                memo[keyValue[0]] = keyValue[1];
                return memo;
            }, {});

            if (query.access_token)
            {
                let auth = "{\"access_token\":\""+query.access_token +"\",\"token_type\":\"\Bearer\",\"expires_in\":\"3600\"}";
                localStorage.setItem('scientia-session-authorization', auth);
                access_token = query.access_token;
            }
        }
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
        
    //if (access_token=="") window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`
        }
    };
    let urlWithArg = url + 'api/UserProfile';

    let result = await axios.get(urlWithArg, headers);
    
    return result.data;

}

const getPermissionGroup = async function (payload){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    //if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`
        }
    };

    let urlWithArg = url + 'api/UserProfile/PermissionGroup';

    let result = await axios.get(urlWithArg, headers);
    
    return result.data;

}

export const userProfileService = { getUserProfile, getPermissionGroup }


// WEBPACK FOOTER //
// ./src/api/user-profile.service.js